import { Translations } from './localization'
import { IS_EQT_FOUNDATION } from './site'
import { isNullOrWhiteSpace } from './string'

const EQT_FOUNDATION_TEAM_ORDER = [
  'executiveBoard',
  'eqtFoundationCommittee',
  'managementTeam',
  'volunteers',
]

const EQT_WEB_TEAM_ORDER = [
  'advisoryProfessionals',
  'clientRelations',
  'specialistFunctions',
]

export const TEAM_ORDER = IS_EQT_FOUNDATION
  ? EQT_FOUNDATION_TEAM_ORDER
  : EQT_WEB_TEAM_ORDER

export const teamCompareFunction = (left: string, right: string): number =>
  TEAM_ORDER.indexOf(left) - TEAM_ORDER.indexOf(right)

export const getTeamDisplayName = (
  translations: Translations,
  teamName: string | null
): string | null => {
  if (isNullOrWhiteSpace(teamName)) {
    return teamName
  }

  if (teamName in translations) {
    return translations[teamName] ?? ''
  }

  return teamName
}
